const namespace = 'APP_FILTER_AND_SORT/';

export const TOGGLE_B_FILTER = namespace + 'TOGGLE_B_FILTER';
export const ADD_B_FILTERS = namespace + 'ADD_B_FILTERS';

export const ADD_N_FILTERS = namespace + 'ADD_N_FILTERS';

export const TOGGLE_PET_FRIENDLY_SELECTED = namespace + 'TOGGLE_PET_FRIENDLY_SELECTED';
export const SET_PET_FRIENDLY_SELECTED = namespace + 'SET_PET_FRIENDLY_SELECTED';

export const UPDATE_MIN_VALUE = namespace + 'UPDATE_MIN_VALUE';
export const UPDATE_MAX_VALUE = namespace + 'UPDATE_MAX_VALUE';

export const SET_RESULTS_APPLIED_SORT = namespace + 'SET_RESULTS_APPLIED_SORT';

export const RESET_ALL_FILTERS = namespace + 'RESET_ALL_FILTERS';
